<div class="relative cursor-pointer">
  <button
    class="btn w-full justify-between btn-outline md:hidden"
    [ngClass]="{
      'bg-zinc-900 text-white hover:text-zinc-900': isOpened(),
    }"
    (click)="toggle()"
  >
    <span [ngClass]="{ 'font-semibold': selectedValue() !== null }">
      {{
        (selectedValue() !== null
          ? selectedValue()!.label
          : 'components.filter.filterOn'
        ) | translate: { type: title() }
      }}
    </span>
    <img
      class="ml-auto h-4 w-4"
      [ngSrc]="
        isOpened()
          ? 'assets/icons/minus_icon_white.svg'
          : 'assets/icons/plus_icon_black.svg'
      "
      alt="Plus Icon"
      width="16"
      height="16"
    />
  </button>
  <div
    class="top-12 left-0 z-20 flex w-full flex-col overflow-hidden rounded-lg bg-white transition max-md:absolute md:flex-row md:gap-x-5"
    [ngClass]="
      isOpened()
        ? 'max-h-fit border border-gray-500 px-5 py-4 md:border-0 md:p-0'
        : 'max-md:max-h-0'
    "
  >
    @for (chip of chips(); track chip) {
      <button
        class="flex items-center justify-start py-2.5 md:btn md:btn-outline"
        [ngClass]="{
          'btn-active': selectedValue()?.value === chip.value,
        }"
        [attr.aria-pressed]="selectedValue()?.value === chip.value"
        (click)="selectChip(chip)"
      >
        <span>{{ chip.label | translate }}</span>
        @if (selectedValue()?.value === chip.value) {
          <img
            class="ml-auto md:hidden"
            src="assets/icons/check.svg"
            alt="Check Icon"
          />
        }
      </button>
    }
  </div>
</div>
